/**
 * 单个slide小图显示
 */
<template lang="pug">
  div
    img(width="100%" height="100%" :src="slideUrl" alt="" class="flex-img__image" )
</template>

<script>
import apiImg from '@/apis/commuCore'
export default {
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      slideUrl: ''
    }
  },
  mounted () {
    // 请求图片数据后 变成本地地址
    apiImg.downloadFile(this.GLOBAL.uploadHost + 'illustration/downloadUrl?url=' + this.url).then(res => {
      this.slideUrl = window.URL.createObjectURL(res)
    })
  }
}
</script>
